const TYPE = "formaPagto";
const formaPagamentoModule = {
  findAll: async (dbConnection, limite = null) => {
    let formasPagamento = [];
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
      },
      limit: limite === null ? 1000 : limite,
    });

    if (result.docs.length) {
      formasPagamento = result.docs;
    }

    return formasPagamento;
  },
  findAllByDesc: async (dbConnection, desc) => {
    desc = desc.toUpperCase();
    let formasPagamento = [];
    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        desc: { $regex: desc },
      },
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      formasPagamento = result.docs;
    }

    return formasPagamento;
  },
  findByIdIntegracao: async (dbConnection, idIntegracao) => {
    let formaPagamento = null;
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        idIntegracao: { $eq: idIntegracao },
      },
    });

    if (result.docs.length) {
      formaPagamento = result.docs[0];
    }

    return formaPagamento;
  },
};

export default formaPagamentoModule;
